module.exports = __webpack_public_path__ + "static/hip-flash-new-5-fa7aa1cb1a7c3e47660d31bd357b94a6.jpg";